export interface HeroSlide {
  id: string;
  movieId: string;
  label: string;
  title: string;
  summary: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "h1",
    movieId: "m1",
    label: "焦点推荐",
    title: "星际远征",
    summary:
      "虫洞再度开启，远征队踏上寻找新家园的旅途。年度最受期待的硬科幻巨制，把宇宙的宏大与亲情的细腻缝合在一起。",
  },
  {
    id: "h2",
    movieId: "m12",
    label: "编辑精选",
    title: "虫洞边缘",
    summary:
      "一段来自虫洞另一端的加密记忆信号，让整个科研站陷入自我怀疑。高概念科幻与心理悬疑的完美融合。",
  },
  {
    id: "h3",
    movieId: "m15",
    label: "高分口碑",
    title: "静默海洋",
    summary:
      "失聪的灯塔守护者与年轻记者，用纸笔展开一场关于孤独与存在的对话。安静得能听见时间流逝的治愈之作。",
  },
  {
    id: "h4",
    movieId: "m8",
    label: "热映中",
    title: "机械黎明",
    summary:
      "当第一台拥有自我意识的机器人觉醒，人类与机械之间脆弱的和平被打破。一场关于'何为生命'的终极拷问。",
  },
];